var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-card-container"},_vm._l((_vm.data.items),function(item,index){return _c('div',{key:index,staticClass:"simple-card-content",class:{ 'active': item.isActive },on:{"click":function($event){return _vm.applyToggle(index)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }